// extracted by mini-css-extract-plugin
export var divider = "_f5-7";
export var itemsToggle = "_f5-8";
export var mergeModal = "_f5-1";
export var optionCard = "_f5-4";
export var radioGroup = "_f5-6";
export var radioOption = "_f5-0";
export var selected = "_f5-5";
export var shipmentOptions = "_f5-2";
export var tableOptions = "_f5-3";